import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import LoadingButton from '@shared/components/buttons/LoadingButton/LoadingButton';

interface WarningDialogProps {
  open: boolean;
  title: string;
  description: string;
  outlinedButtonText: string;
  containedButtonText: string;
  loading?: boolean;
  onOutlinedClick: () => void;
  onContainedClick: () => void;
  onClose: () => void;
}

export const WarningDialog = ({
  open,
  title,
  description,
  outlinedButtonText,
  containedButtonText,
  loading,
  onOutlinedClick,
  onContainedClick,
  onClose,
}: WarningDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} variant="warning">
      <Stack className="warning-dialog-content">
        <Box className="warning-dialog-close" onClick={onClose}>
          <CloseIcon sx={{ fontSize: 24 }} />
        </Box>

        <Stack className="warning-dialog-icon">
          <ErrorOutlineRoundedIcon sx={{ fontSize: 84 }} />
        </Stack>

        <Typography variant="heading.subsection" color="border.black">
          {title}
        </Typography>

        <Typography variant="body.sm" color="border.black" sx={{ lineHeight: 1.3, maxWidth: 380 }}>
          {description}
        </Typography>

        <Stack direction="row" className="warning-dialog-actions">
          <Button variant="outlined" onClick={onOutlinedClick}>
            <Typography variant="label.buttonEmphatic" color="inherit">
              {outlinedButtonText}
            </Typography>
          </Button>
          <LoadingButton variant="contained" onClick={onContainedClick} loading={loading}>
            <Typography variant="label.buttonEmphatic" color="inherit">
              {containedButtonText}
            </Typography>
          </LoadingButton>
        </Stack>
      </Stack>
    </Dialog>
  );
};
